$(function () {
  var ding = window.innerHeight;
  var show = false;
  $(window).bind('scroll', function () {
    if ($(window).scrollTop() >= ding && !show) {
      $('.cus_addtocard').css({
        position: 'fixed',
      });
      show = true;
    }
    if ($(window).scrollTop() < ding && show) {
      $('.cus_addtocard').css({
        position: 'static',
      });
      show = false;
    }
  });

  $('.cus_tan_add product-form .product-form__add.js-product-buttons.product-form__add--dynamic',
  ).prepend($('.product-single__box__block--quantity_selector'));
});
$(document).ready(function () {
  //virtual sales quanlity
  var reviewNum = $('.jdgm-rev-widg').attr('data-number-of-reviews') || 1;
  reviewNum = reviewNum * 2;
  var random = parseInt(Math.random() * 50);
  const num = parseInt(localStorage.getItem('quanlity' + reviewNum)) || parseInt(reviewNum);
  var saleQuanlity = num + random;

  localStorage.setItem('quanlity' + reviewNum, saleQuanlity);

  $('.virtual-sales').html('1週間で ' + saleQuanlity + ' 点販売');
});
